module.exports = __webpack_public_path__ + "static/img/regulacni_ventil_3_zavitovy.5e99e4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/regulacni_ventil_3_zavitovy.png
// module id = jFlT
// module chunks = 1